import type React from 'react';
import type { ReactNode } from 'react';

import {
  DREAM_COMPONENTS_CONTEXT_DEFAULT_VALUES,
  DreamComponentsContext,
  type DreamComponentsContextType,
} from './context.js';

interface DreamComponentsProviderProps {
  children: ReactNode;
  context: DreamComponentsContextType;
}

export const DreamComponentsProvider: React.FC<DreamComponentsProviderProps> = ({ children, context }) => {
  return (
    <DreamComponentsContext.Provider value={{ ...DREAM_COMPONENTS_CONTEXT_DEFAULT_VALUES, ...context }}>
      {children}
    </DreamComponentsContext.Provider>
  );
};
